import { apiEndpoints } from '@/lib/env'
import { createFileRoute } from '@tanstack/react-router'
// @versepen/pulse has been removed
const FeedbackWidget = (_props: any) => null
import { APP_NAME } from '@/lib/env';

export const Route = createFileRoute('/demo/pulse')({
  component: PublicPulseDemo,
})

function PublicPulseDemo() {
  // Demo credentials for the public demo
  const demoApiKey = '1234567890'
  const demoWorkspaceId = 'test-workspace'
  const apiEndpoint = `${apiEndpoints.api}/pulse`

  return (
    <div className='max-w-4xl mx-auto p-8'>
      <h1 className='text-3xl font-bold mb-6'>{APP_NAME} Pulse Demo</h1>

      <div className='prose mb-8'>
        <p>
          See how the {APP_NAME} Pulse feedback widget works in a real environment.
        </p>
      </div>
      
      <div id="demo-container" className="border p-6 rounded-lg mb-8 bg-white">
        <h2 className="text-xl font-semibold mb-4">Example Documentation</h2>
        <p className="mb-4">This is a sample document that demonstrates how the widget looks on your site.</p>
        <p className="mb-4">Try clicking the feedback buttons or selecting text to leave a comment!</p>
        <p className="mb-4">When selecting text, a floating toolbar will appear above your selection.</p>
        
        {/* The actual feedback widget */}
        <FeedbackWidget 
          workspaceId={demoWorkspaceId}
          apiKey={demoApiKey}
          apiEndpoint={apiEndpoint}
        />
      </div>
      
      <div className='bg-slate-50 p-6 rounded-lg'>
        <h2 className='text-xl font-semibold mb-4'>Get Started</h2>
        <p>Sign up for {APP_NAME} to add this widget to your own documentation.</p>
        <a
          href='/signup'
          className='mt-4 inline-block bg-blue-600 text-white px-4 py-2 rounded'
        >
          Sign Up Free
        </a>
      </div>
    </div>
  )
}